import * as React from "react";
import { OpenDashContext } from "..";
export function useOpenDashApp() {
    return React.useContext(OpenDashContext);
}
//# sourceMappingURL=useOpenDashApp.js.map